<script>
    export default {
        props: {
            popup: Object,
        },
        async mounted() {
            const popupTime = this.popup.isLongPopup ? 20000 : 2000;
            setTimeout(this.deletePopup, popupTime);
        },
        methods: {
            async deletePopup() {
                await this.$store.commit('POPUP_DELETE', this.popup.id);
            }
        }
    }
</script>


<template>
    <div :style="`background-color: ${popup['color']};`" class="popup_info_object">
        <label class="popup_title">{{ popup['title'] }}</label>
        <template v-if="Array.isArray(popup['description'])">
            <label
                v-for="(descriptionValue, descriptionIndex) in popup['description']" :key="descriptionIndex"
            >{{ descriptionValue }}</label>
        </template>
        <label v-else>{{ popup['description'] }}</label>
    </div>
</template>
